<template>
  <div class="result">
    <div class="bg-img">
      <img
        src="https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/snow11.png"
        alt=""
        style="position: fixed; left: 0rem; top: 10rem; z-index: 99; width:2.4rem"
      />
      <img
        src="https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/snow21.png"
        alt=""
        style="position: fixed; right: 0rem; top: 5rem; z-index: 99; width:2.7rem"
      />
      <img
        src="https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/snow31.png"
        alt=""
        style="position: fixed; right: 1rem; top: 18rem; z-index: 99; width:3rem"
      />
      <img
        src="https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/snow41.png"
        alt=""
        style="position: fixed; left: 1rem; bottom: 1rem; z-index: 99; width:2.1rem"
      />
      <img
        src="https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/snow5.png"
        alt=""
        style="position: fixed; right: 1rem; bottom: 1rem; z-index: 99; width:1.6rem"
      />
    </div>
    <div ref="fixed" class="fixed">
      <div class="restart" v-if="restartShow" @click="restart">
        <img
          class="restart-img"
          src="https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/close.png"
          alt=""
        />
        <span class="restart-title" >restart</span>
      </div>
      <div class="title">Santa is coming</div>
    </div>
    <div class="result-content" :style="{marginTop: `${restartShow ? 5.24 : 3.5}rem`}">
      <div
        class="scorll"
        :style="{
          height: `${resultContentHeight}px`,
          overflow: 'scroll'
        }"
      >
        <div class="theme-img">
          <img :src="santaList[resultSanta] && santaList[resultSanta].imgUrl" alt="">
        </div>
        <div class="theme-title">{{santaList[resultSanta].name}}</div>
        <div class="theme-desc">
          {{santaList[resultSanta] && santaList[resultSanta].desc}}
        </div>
      </div>
      <div class="theme-buttom">
        <button class="share" @click="share">See <br> friend's choice</button>
        <button class="win" @click="win">
          <!-- {{ iosSafari ? "share" : "Win $15.99" }} -->
          {{ isPicku ? 'Win $15.99' : $device === 'IOS' ? 'Save the picture' : 'Win $15.99'}}
        </button>
      </div>
    </div>
    <!-- PICKU 内部分享弹窗 -->
    <div class="share-pop" v-if="pickuShareShow">
      <div class="black-bg"></div>
      <div class="share-content">
        <div class="button-group">
          <div class="button" @click="shareContent('facebook')">
            <img
              src="https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/face.png"
              alt=""
            />
            <span>Facebook</span>
          </div>
          <div class="button" @click="shareContent('whatsapp')">
            <img
              src="https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/whatsapp.png"
              alt=""
            />
            <span>WhatsApp</span>
          </div>
          <div class="button" @click="shareContent('messenger')">
            <img
              src="https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/messenger.png"
              alt=""
            />
            <span>Messenger</span>
          </div>
          <div class="button" @click="shareContent('Twitter')">
            <img src="https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/twitter.png" alt="" />
            <span>Twitter</span>
          </div>
        </div>
        <div class="cancel" @click="pickuShareShow = false">Cancel</div>
      </div>
    </div>
    <!-- Android/chrome 分享引导页弹窗 -->
    <div class="chrome-pop" v-if="androidChrome">
      <div class="black-bg"></div>
      <div class="chrome-content">
        <div class="step">
          <div class="step-title">Step1.</div>
          <div class="step-desc">Click ‘more’ in the browser</div>
          <img
            class="step-info-img"
            src="https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/share/pic1.png"
            alt=""
          />
        </div>

        <div class="step">
          <div class="step-title">Step2.</div>
          <div class="step-desc">Click ‘Share’ and share with your friends</div>
        </div>

        <div class="know" @click="androidChrome=false">Ok, I know</div>
      </div>
    </div>
    <!-- facebook 分享引导页弹窗 -->
    <div class="facebook-pop" v-if="messengerFacebookShow">
      <div class="black-bg"></div>
      <div class="facebook-content">
        <div class="step">
          <div class="step-title">Step1.</div>
          <div class="step-desc">Click ‘more’ and ‘share’ in the browser</div>
          <img
            class="step-info-img"
            src="https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/share/pic2.png"
            alt=""
          />
        </div>

        <div class="step">
          <div class="step-title">Step2.</div>
          <div class="step-desc"> ‘Send in Messenger’ or other in ‘More Options’</div>
          <img
            class="step-info-img"
            src="https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/share/pic3.png"
            alt=""
          />
        </div>

        <div class="know" @click="messengerFacebookShow = false">Ok, I know</div>
      </div>
    </div>
    <!-- ios保存图片引导弹窗 -->
    <div class="ios-save-pop" v-if="saveIosShow">
      <div class="black-bg"></div>
      <div class="ios-content">
        <div class="step">
          <div class="step-title">Step1.</div>
          <div class="step-desc">Long press the picture above</div>
        </div>

        <div class="step">
          <div class="step-title">Step2.</div>
          <div class="step-desc">Click ‘Add to photos’</div>
          <img
            class="step-info-img"
            src="https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/share/pic4.png"
            alt=""
          />
        </div>

        <div class="know" @click="saveIosShow = false">Ok, I know</div>
      </div>
    </div>
    <!-- ios分享弹窗 -->
    <div class="ios-share-pop" v-if="shareIosShow">
      <div class="black-bg"></div>
      <div class="ios-content">
        <div class="step">
          <div class="step-title">Step1.</div>
          <div class="step-desc">Click ‘Share’ in the browser</div>
        </div>

        <div class="step">
          <div class="step-title">Step2.</div>
          <div class="step-desc">Send to your friends on social media.</div>
          <img
            class="step-info-img"
            src="https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/share/pic5.png"
            alt=""
          />
        </div>

        <div class="know" @click="shareIosShow = false">Ok, I know</div>
      </div>
    </div>
    <!-- 重新开始弹窗 -->
    <div class="restart-pop" v-if="restartClick">
      <div class="black-bg"></div>
      <div class="restart-content">
        <div class="restart-info">
          <div class="restart-title">Try again in PickU</div>
          <div class="restart-desc">
            Christmas quiz can be launched multiple times in PickU app.
          </div>
          <div class="download-button"  @click="downLoadPicku">Download</div>
        </div>
        <div class="restart-close" @click="restartClick = false">
          <img
            src="https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/pop_close.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <!-- 获取奖励弹窗 -->
    <div class="win-pop" v-if="winClick">
      <div class="black-bg"></div>
      <div class="win-content">
        <div class="win-content">
          <div class="win-info">
            <div class="win-title">Download PickU and Win $15.99 Prize</div>
            <div class="win-desc">
              <div class="step">
                <div class="step-title">Step1.</div>
                <div class="step-desc">
                  Now you have got your “customized Santa” image, download PickU on Google Play, then you can take photo with your own Santa by using AI-cutout function. You can also change the Christmas backgroud, stickers and effects we have offered.
                </div>
              </div>

              <div class="step">
                <div class="step-title">Step2.</div>
                <div class="step-desc">
                  Post the group photo to Instagram @picku_us with #PickuChristmas #PickuSanta, collect "Like" , then send us a screenshot of your post  and your login email address before 23:59 US time on December 26.
                </div>
              </div>

              <div class="step">
                <div class="step-title">Step3.</div>
                <div class="step-desc">
                  We will give prizes worth $15.99 to the top three users who won the most "Like"and $2.99 to the top 4-20 users.Users won the prize can redeem our free members. PickU reserves the right of final interpretation.
                </div>
              </div>
            </div>
            <div class="download-button" @click="downLoadPicku">
              {{ isPicku ? "Take a group photo" : "Get PickU on Google Play" }}
            </div>
          </div>
          <div class="win-close" @click="winClick = false">
            <img
              src="https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/pop_close.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global gtag */

export default {
  name: 'result',
  data () {
    return {
      resultContentHeight: 750,
      pickuShareShow: false, // 如果在picku内部点击则为true显示picku内部的分享
      restartShow: false, // restart按钮是否显示
      restartClick: false, // restart按钮是否点击
      androidChrome: false, // 是否为Android/chrome浏览器中
      messengerFacebook: false, // 是否为在Facebook中
      messengerFacebookShow: false, // facebook引导页展示
      iosSafari: false, // 是否为ios的safari中
      winClick: false, // 是否点击了获取金币的按钮
      saveIosShow: false, // 保存时ios引导页
      shareIosShow: false, // 点击分享时，如果是ios则这个为true，显示ios的分享引导界面
      isPicku: false, // 判断是否是picku内部的
      pickuVersion: 1.0, // 当前picku的版本
      santaList: {
        alcoholicSanta: {
          name: 'Alcoholic Santa',
          imgUrl: 'https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/result/Alcoholic Santa.jpg',
          desc: `You are a maverick and powerful person! You don't even care about Christmas, the days with wine are good holidays! Your customized Santa just like you. Instead of giving presents to everybody, he just want to drink with people! Cheers and take photo with your maverick Santa Claus.`,
          communityId: '63621',
          templateId: '15271',
          categoryId: '10020875',
          title: 'Special Santa For You',
          selected: '5'
        },
        astronautSanta: {
          name: 'Astronaut Santa',
          imgUrl: 'https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/result/Astronaut Santa.jpg',
          desc: `You are intelligent, studious and motivated, You are interested in mystery things. Your customized Santa is also a wise man, he didn't want to climb the chimney, he want to go to outer space! Go with him and take a memorable photo! `,
          communityId: '63627',
          templateId: '15276',
          categoryId: '10020875',
          title: 'Special Santa For You',
          selected: '6'
        },
        richSanta: {
          name: 'Rich Santa',
          imgUrl: 'https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/result/Rich Santa.jpg',
          desc: `You are a powerful and generous person! Your customized Santa is super rich! A bag of money is a Christmas gift for you. Look at how cool he is ! Do you want to become as rich as him? Come take a lucky photo with him! `,
          communityId: '63624',
          templateId: '15273',
          categoryId: '10020875',
          title: 'Special Santa For You',
          selected: '1'
        },
        stylishSanta: {
          name: 'Stylish Santa',
          imgUrl: 'https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/result/Stylish Santa.jpg',
          desc: `You are a stylish person! Your customized Santa is a fashionable sexy Christmas girl. You can dress like her to stay 'cool' on Christmas if you are a woman! If you are a man, don't miss the chance to take a picture with the Christmas girl!`,
          communityId: '63625',
          templateId: '15274',
          categoryId: '10020875',
          title: 'Special Santa For You',
          selected: '2'
        },
        supercoolSanta: {
          name: 'Supercool Santa',
          imgUrl: 'https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/result/Supercool Santa.jpg',
          desc: `You are a passionate and interesting person ! You are so smart, you can always come up with some tricks to attract everybody' attention during special holidays like Christmas! Come take a supercool photo with this customized Santa with your friends and family!
`,
          communityId: '63622',
          templateId: '15272',
          categoryId: '10020875',
          title: 'Special Santa For You',
          selected: '4'
        },
        surfingSanta: {
          name: 'Surfing Santa',
          imgUrl: 'https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/result/Surfing Santa.jpg',
          desc: `You are an optimistic and relaxed person! All you want to do during the Christmas holidays is get away from the stresses and have a good rest. Your customized Santa just like you, he's tired of handing out Christmas presents! He just want to go to Hawaii on vacation with people. Go surfing with your leisurely Santa and take a great photo!`,
          communityId: '63626',
          templateId: '15275',
          categoryId: '10020875',
          title: 'Special Santa For You',
          selected: '3'
        }
      },
      resultSanta: ''
    }
  },
  created () {
    // 获取上一步答题获取的圣诞老人形象分
    this.resultSanta = this.$route.params.santaName
    if (!this.resultSanta) {
      this.$router.push('/question')
    }
  },
  mounted () {
    gtag('event', 'Xmas_result_page_show')
    // 获取H5所在的内部设备标识
    this.getInnerType()
    // 如何在PICKU内部，或者安卓内，则显示restart
    if (this.isPicku || this.$device === 'Android') {
      this.restartShow = true
    }
    // 计算页面的高
    setTimeout(this.getResultContentHeight, 500)
  },
  methods: {
    getResultContentHeight () {
      const deviceWidth =
        document.documentElement.clientWidth || window.screen.width || 320
      const headerHeight = this.restartShow ? 4.5 : 2.5
      const devicePixelRatio = window.devicePixelRatio || 1
      const clientHeight = window.clientHeight
        ? window.clientHeight
        : document.body.clientHeight || window.screen.height
      const rootFontSize = window.rootFontSize
        ? window.rootFontSize
        : Math.ceil((deviceWidth * 16) / 320)
      this.resultContentHeight = clientHeight - headerHeight * rootFontSize - 6.5 * rootFontSize
      console.log(
        this.resultContentHeight,
        clientHeight,
        devicePixelRatio,
        rootFontSize
      )
    },
    share () {
      // 如果在picku的webview中，则显示分享图标
      if (this.isPicku) {
        gtag('event', 'Xmas_built_share_dialog_show')
        this.pickuShareShow = true
      } else if (this.messengerFacebook) {
        gtag('event', 'Xmas_result_page_share_btn_click')
        // 在Facebook中，则显示facebook的分享引导页
        this.messengerFacebookShow = true
      } else if (this.iosSafari) {
        gtag('event', 'Xmas_result_page_share_btn_click')
        this.shareIosShow = true
      } else {
        gtag('event', 'Xmas_result_page_share_btn_click')
        this.androidChrome = true
      }
    },
    win () {
      // 获取奖励
      // 1、首先判断是否为ios的safari打开的，如果是则调用保存图片的弹窗
      if (this.$device === 'IOS') {
        this.saveIosShow = true
        gtag('event', 'Xmas_result_page_save_btn_click')
      } else {
        this.winClick = true
        gtag('event', 'Xmas_result_page_win_btn_click')
        gtag('event', 'Xmas_win_dialog_show')
      }
      // this.winClick = true
    },
    // 点击restart按钮
    restart () {
      gtag('event', 'Xmas_result_page_restart_btn_click')
      // 判断是否在picku内部，如果在则返回到答题页
      if (this.isPicku) {
        this.$router.push({ name: 'question', params: { isStartIn: true } })
      } else {
        this.restartClick = true
        gtag('event', 'Xmas_restart_dialog_show')
      }
    },
    // 下载Picku
    downLoadPicku () {
      // 判断是否为picku内部的,
      if (this.isPicku) {
        gtag('event', 'Xmas_win_dialog_take_btn_click')
        // 判断版本是否为1.35及一下
        if (this.pickuVersion <= 135) {
          const deeplink = `xapplink://com.swifthawk.picku.free/template_detail?extra_id=10020875&extra_title=Special Santa For You&selected=${this.santaList[this.resultSanta].templateId}`
          window.location.href = deeplink
        } else if (this.pickuVersion >= 136) {
          const deeplink = `xapplink://com.swifthawk.picku.free/details_routes?communityId=${this.santaList[this.resultSanta].communityId}&templateId=${this.santaList[this.resultSanta].templateId}&categoryId=10020875&title=Special Santa For You`
          window.location.href = deeplink
        }
      } else {
        gtag('event', 'Xmas_win_dialog_download_btn_click')
        const deeplink = `xapplink://com.swifthawk.picku.free/details_routes?communityId=${this.santaList[this.resultSanta].communityId}&templateId=${this.santaList[this.resultSanta].templateId}&categoryId=10020875&title=Special Santa For You`
        window.location.href =
         'https://play.google.com/store/apps/details?id=com.swifthawk.picku.free&referrer=' + encodeURIComponent('utm_source=868017&deeplink=' + encodeURIComponent(deeplink))
      }
    },
    // 判断当前H5在什么地方
    getInnerType () {
      var ua = navigator.userAgent.toLowerCase() // 获取判断用的对象，浏览器的UA
      console.log(ua)
      // 首先判断是否在picku里面
      if (window.JS_BRIDGE_PLUGINS) {
        this.isPicku = true
        this.pickuVersion = window.JS_BRIDGE_PLUGINS.Base.versionCode()
      } else if ( // 判断是否为Facebook
        ua.indexOf('fban') > -1 ||
        ua.indexOf('fbdv') > -1 ||
        ua.indexOf('fbav') > -1
      ) {
        this.messengerFacebook = true
      } if (this.$device === 'IOS') { // 判断是否为Safari浏览器
        this.iosSafari = true
      }
    },
    // 分享到社交媒体
    shareContent (type) {
      let link = location.href.split('/')
      link = link.slice(0, link.length - 2)
      link.push(this.resultSanta)
      link = link.join('/')
      link = link + '.html'
      const shareTitle = `I have a customized Santa in 2020 ! Come and pick yours !`
      switch (type) {
        case 'facebook': {
          setTimeout(function () {
            window.location.href = 'https://www.facebook.com/sharer?u=' + encodeURIComponent(link)
          }, 5)
          window.location.href = 'fb://facewebmodal/f?href=' + encodeURI('https://www.facebook.com/sharer?u=' + encodeURIComponent(link))
          break
        }
        case 'whatsapp': {
          window.location.href = `whatsapp://send?text=${encodeURIComponent(link)}`
          break
        }
        case 'messenger': {
          window.location.href = `fb-messenger://share?link=${encodeURIComponent(link)}`
          break
        }
        case 'Twitter': {
          setTimeout(() => {
            const href = `https://twitter.com/intent/tweet?text=${shareTitle}&url=${link}`
            window.location.href = href
          }, 5)
          window.location.href = `twitter://post?message=${shareTitle}&url=${encodeURIComponent(link)}`
          break
        }
      }
    }
  }
}
</script>

<style lang='less' scope>
.result {
  position: relative;
  height: 100%;
  width: 100%;
  background-image: linear-gradient(#c9a5b4, #33255a);
  .bg-img {
    position: absolute;
    height: 100%;
    width: 100%;
    background: url(https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/snow.png)
      repeat;
  }
  .fixed {
    position: absolute;
    width: 90%;
    top: 0;
    margin: 1rem;
    .restart {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .restart-img {
        width: 1.2rem;
        height: 1.2rem;
      }
      .restart-title {
        margin-left: 0.2rem;
        font-weight: bold;
        color: #ffffff;
        font-size: 0.8rem;
      }
    }
    .title {
      font-size: 1.21rem;
      font-weight: bold;
      color: #ffffff;
    }
  }
  .result-content {
    position: absolute;
    overflow: scroll;
    width: 100%;
    .theme-img {
      width: 17rem;
      height: 17rem;
      border-radius: 0.5rem;
      background-color: #ffffff;
      margin: 0 auto;
      img {
        width: 17rem;
        height: 17rem;
        border-radius: 0.5rem;
      }
    }
    .theme-title {
      margin: 1rem auto 0.5rem auto;
      text-align: center;
      width: 17rem;
      font-size: 1rem;
      font-weight: bold;
      color: #fff;
    }
    .theme-desc {
      margin: 0 auto;
      text-align: left;
      width: 17rem;
      font-size: 0.79rem;
      line-height: 1rem;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.64);
    }
    .theme-buttom {
      position: fixed;
      bottom: 0.5rem;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      width: 17rem;
      margin: 1rem auto;
      justify-content: space-between;
      .share {
        border: none;
        width: 6rem;
        height: 2.8rem;
        background: rgba(255, 255, 255, 0.05);
        box-shadow: 0px 0.1rem 0.6rem 0px rgba(37, 4, 50, 0.33),
       inset 0px 0.1rem 1rem 0px rgba(255, 255, 255, 0.2), inset 0.1rem 0.1rem 0.3rem 0.1rem #ffffff;
        border-radius:2.8rem;
        font-size: 0.68rem;
        font-weight: bold;
        color: #fff;
        line-height: 0.84rem;
      }
      .win {
        border: none;
        width: 10rem;
        height: 2.8rem;
        background: rgba(255, 255, 255, 0.05);
        box-shadow: 0px 0.1rem 0.6rem 0px rgba(37, 4, 50, 0.33),
       inset 0px 0.1rem 1rem 0px rgba(255, 255, 255, 0.2), inset 0.1rem 0.1rem 0.3rem 0.1rem #ffffff;
        border-radius: 2.8rem;
        font-size: 0.9rem;
        font-weight: bold;
        color: #fff;
        line-height: 1rem;
      }
    }
  }
  .black-bg {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.85);
    width: 100%;
    height: 100%;
  }
  .share-pop {
    .share-content {
      position: fixed;
      bottom: 1rem;
      width: 100%;
      .button-group {
        width: 17rem;
        height: 5.8rem;
        background-color: #fff;
        margin: 0 auto;
        border-radius: 0.5rem;
        display: flex;
        justify-content: space-around;
        .button {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          img {
            width: 1.6rem;
            height: 1.6rem;
          }
          span {
            font-size: 0.5rem;
          }
        }
      }
      .cancel {
        width: 17rem;
        height: 2.7rem;
        background-color: #fff;
        margin: 0.5rem auto;
        border-radius: 0.5rem;
        text-align: center;
        line-height: 2.7rem;
        font-weight: bold;
        color: #1a181b;
      }
    }
  }
  .restart-pop {
    .restart-content {
      position: fixed;
      top: 30%;
      height: 14rem;
      width: 17rem;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      .restart-info {
        height: 14rem;
        width: 15rem;
        padding: 1rem 1rem;
        background-color: #fff;
        border-radius: 1rem;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .restart-title {
          font-size: 1.5rem;
          font-weight: bold;
          color: #1a181b;
          line-height: 1.5rem;
          text-align: left;
        }
        .restart-desc {
          font-weight: 400;
          text-align: left;
          color: #524d58c7;
        }
        .download-button {
          margin: 0 auto;
          width: 100%;
          height: 2.52rem;
          background: linear-gradient(231deg, #ff27cd 0%, #7844ff 100%);
          border-radius: 2.52rem;
          font-weight: bold;
          color: #ffffff;
          line-height: 2.52rem;
        }
      }
      .restart-close {
        width: 100%;
        height: 1rem;
        text-align: center;
        margin-top: 1rem;
        img {
          width: 2rem;
          height: 2rem;
        }
      }
    }
  }
  .ios-save-pop {
    .ios-content {
      position: fixed;
      top: 50%;
      height: 17rem;
      width: 17rem;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }
  }
  .ios-share-pop {
    .ios-content {
      position: fixed;
      top: 50%;
      height: 15rem;
      width: 17rem;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }
  }
  .win-pop {
    .win-content {
      position: fixed;
      top: 45%;
      height: 22.6rem;
      width: 17rem;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      text-align: center;
      .win-info {
        height: 19rem;
        width: 13.2rem;
        padding: 2.2rem 1.9rem 1.26rem 1.9rem;
        background-color: #fff;
        border-radius: 1rem;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .win-title {
          font-size: 1rem;
          font-weight: bold;
          color: #1a181b;
          line-height: 1.2rem;
          text-align: left;
        }
        .win-desc {
          font-weight: 400;
          text-align: left;
          height: 11.4rem;
          overflow: scroll;
          color: #524d58c7;
          .step {
            .step-title {
              color: #524d58;
              font-weight: bold;
              font-size: 0.64rem;
              line-height: 0.73rem;
              margin: 0.5rem 0;
            }
            .step-desc {
              color: rgba(82, 77, 88, 0.6);
              font-size: 0.64rem;
              line-height: 0.84rem;
              font-weight: 400;
              margin: 0.5rem 0;
            }
          }
        }
        .download-button {
          margin: 0 auto;
          width: 100%;
          height: 2.53rem;
          background: linear-gradient(231deg, #ff27cd 0%, #7844ff 100%);
          border-radius: 2.53rem;
          font-weight: bold;
          color: #ffffff;
          line-height: 2.53rem;
          font-size: 0.8rem;
          position: relative;
          &::before {
            position: absolute;
            content: '';
            width: 100%;
            height: 2.53rem;
            bottom: 3rem;
            left: 0;
            background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
          }
        }
      }
      .win-close {
        width: 100%;
        height: 1rem;
        text-align: center;
        margin-top: 1rem;
        img {
          width: 2rem;
          height: 2rem;
        }
      }
    }
  }
  .chrome-pop {
    .chrome-content {
      position: fixed;
      top: 50%;
      height: 15rem;
      width: 17rem;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }
  }
  .step {
        .step-title {
          color: #fff;
          font-weight: bold;
          font-size: 0.7rem;
          margin: 0.5rem 0;
        }
        .step-desc {
          color: rgba(255, 255, 255, 0.6);
          font-size: 0.7rem;
          font-weight: 400;
          margin: 0.5rem 0;
        }
        .step-info-img {
          width: 11rem;
          margin: 0.5rem 0;
        }
      }
  .know {
    width: 6.63rem;
    height: 2.2rem;
    margin: 0 auto;
    color: #fff;
    border: 5px solid #fff;
    border-radius: 2.2rem;
    line-height: 2.2rem;
    font-size: 0.79rem;
  }
  .facebook-pop {
    .facebook-content {
      position: fixed;
      top: 50%;
      height: 22rem;
      width: 17rem;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }
  }
}
</style>
